import React from "react";
import { UIComponents } from "../ui";
import { CustomBreadcrumbProps } from "./type";

const Breadcrumb = ({ items }: CustomBreadcrumbProps): React.ReactElement => {
  return (
    <UIComponents.breadcrumb>
      <UIComponents.breadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={index}>
              <UIComponents.breadcrumbItem>
                {isLast || (!item.href && !item.onClick) ? (
                  <UIComponents.breadcrumbPage>
                    {item.label}
                  </UIComponents.breadcrumbPage>
                ) : (
                  <UIComponents.breadcrumbLink
                    href={item.href}
                    onClick={(e) => {
                      if (item.onClick) {
                        e.preventDefault();
                        item.onClick();
                      }
                    }}
                  >
                    {item.label}
                  </UIComponents.breadcrumbLink>
                )}
              </UIComponents.breadcrumbItem>
              {!isLast && <UIComponents.breadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </UIComponents.breadcrumbList>
    </UIComponents.breadcrumb>
  );
};

export default Breadcrumb;
